// modules
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// assets
// styles
import 'semantic-ui-css/semantic.min.css';
import './index.css';
// components
import { App } from './containers/App';
import './i18n';
// redux
import store from 'store/Store';

// render top component
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
